// source: pbtypes/gen/vehicle_params_for_phone/vehicle_features.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_vehicle_params_for_phone_ground_launch_availability_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/ground_launch_availability_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_ground_launch_availability_pb);
goog.exportSymbol('proto.vehicle_params_for_phone.VehicleFeatures', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_params_for_phone.VehicleFeatures = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vehicle_params_for_phone.VehicleFeatures, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_params_for_phone.VehicleFeatures.displayName = 'proto.vehicle_params_for_phone.VehicleFeatures';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_params_for_phone.VehicleFeatures.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_params_for_phone.VehicleFeatures} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.VehicleFeatures.toObject = function(includeInstance, msg) {
  var f, obj = {
groundLaunchAvailability: jspb.Message.getFieldWithDefault(msg, 1, 0),
showHeightCeilingToggle: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
phoneTriggersJoystickLanding: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
strobeLights: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
uconSupported: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
allowOtaOverJoysticks: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
allowOtaOverBeacon: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
allowNudgingWhileLanding: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures}
 */
proto.vehicle_params_for_phone.VehicleFeatures.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_params_for_phone.VehicleFeatures;
  return proto.vehicle_params_for_phone.VehicleFeatures.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_params_for_phone.VehicleFeatures} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures}
 */
proto.vehicle_params_for_phone.VehicleFeatures.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vehicle_params_for_phone.GroundLaunchAvailability.Enum} */ (reader.readEnum());
      msg.setGroundLaunchAvailability(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowHeightCeilingToggle(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPhoneTriggersJoystickLanding(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStrobeLights(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUconSupported(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowOtaOverJoysticks(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowOtaOverBeacon(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowNudgingWhileLanding(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_params_for_phone.VehicleFeatures.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_params_for_phone.VehicleFeatures} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.VehicleFeatures.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroundLaunchAvailability();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getShowHeightCeilingToggle();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getPhoneTriggersJoystickLanding();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getStrobeLights();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUconSupported();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAllowOtaOverJoysticks();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAllowOtaOverBeacon();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getAllowNudgingWhileLanding();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional GroundLaunchAvailability.Enum ground_launch_availability = 1;
 * @return {!proto.vehicle_params_for_phone.GroundLaunchAvailability.Enum}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.getGroundLaunchAvailability = function() {
  return /** @type {!proto.vehicle_params_for_phone.GroundLaunchAvailability.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vehicle_params_for_phone.GroundLaunchAvailability.Enum} value
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures} returns this
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.setGroundLaunchAvailability = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool show_height_ceiling_toggle = 2;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.getShowHeightCeilingToggle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures} returns this
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.setShowHeightCeilingToggle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool phone_triggers_joystick_landing = 3;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.getPhoneTriggersJoystickLanding = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures} returns this
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.setPhoneTriggersJoystickLanding = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool strobe_lights = 4;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.getStrobeLights = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures} returns this
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.setStrobeLights = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool ucon_supported = 5;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.getUconSupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures} returns this
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.setUconSupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool allow_ota_over_joysticks = 6;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.getAllowOtaOverJoysticks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures} returns this
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.setAllowOtaOverJoysticks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool allow_ota_over_beacon = 7;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.getAllowOtaOverBeacon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures} returns this
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.setAllowOtaOverBeacon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool allow_nudging_while_landing = 8;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.getAllowNudgingWhileLanding = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleFeatures} returns this
 */
proto.vehicle_params_for_phone.VehicleFeatures.prototype.setAllowNudgingWhileLanding = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


goog.object.extend(exports, proto.vehicle_params_for_phone);
